import { pipe } from 'fp-ts/function';
import * as O from 'monocle-ts/Optional';
import { Action } from 'redux';
import {
  REPORT_ATTACHMENT_DELETE,
  REPORT_ATTACHMENT_PROCESS,
} from 'src/modules/report/actions/ReportActions';
import { ReportState } from 'src/modules/report/types/ReportState';

export function reportAttachmentReducer(state: ReportState, action: Action): ReportState {
  if (REPORT_ATTACHMENT_PROCESS.isSuccess(action)) {
    const attachment = action.data;

    return pipe(
      DATA_LENS,
      O.modify((data) => (
        data.some((other) => other.id === attachment.id)
          ? data.map((other) => (other.id === attachment.id ? attachment : other))
          : data.concat(attachment)
      )),
    )(state);
  }
  if (REPORT_ATTACHMENT_DELETE.is(action)) {
    const attachment = action.data;

    return pipe(
      DATA_LENS,
      O.modify((data) => data.filter((other) => other.id !== attachment.id)),
    )(state);
  }

  return state;
}

const DATA_LENS = pipe(
  O.id<ReportState>(),
  O.prop('data'),
  O.fromNullable,
  O.prop('attachments'),
);
